import React, { useState, useEffect } from 'react';
import { postUpload } from '../ApiServices/AuthService';

const Modal = ({ show, onClose , onCross}) => {
  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.name.endsWith('.xlsx')) {
      setFile(selectedFile);
    } else {
      alert('Please upload a valid .xlsx file.');
    }
  };

  const handleSubmit = () => {
    if (!file) {
      alert('Please select a file before submitting.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);  

    postUpload(formData)
      .then(response => {
        alert('File uploaded successfully!');
        onCross();
        onClose();  
      })
      .catch(error => {
        alert('Error uploading file. Please try again.');
      });
  };

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [show]);

  return (
    show ? (
      <div className="backdrop">
        <div className="modal">
          <button className="close-btn" onClick={onClose}>X</button>
          <div className="upload-section">
            <label htmlFor="file-upload" className="custom-file-upload">
              Choose a .xlsx file
            </label>
            <input id="file-upload" type="file" accept=".xlsx" onChange={handleFileChange} />
          </div>
          <div className='btn-container'>
            <button onClick={handleSubmit} className="submit-btn">Submit</button>
          </div>
        </div>
      </div>
    ) : null
  );
};

export default Modal;
